const progressBar = document.querySelector('.progress');
const currentSlideEl = document.querySelector('.current-slide');
const totalSlideEl = document.querySelector('.total-slide');

const swiper = new Swiper('.mySwiper', {
    loop: true,
    effect: "fade",
    fadeEffect: {
        crossFade: true
    },
    speed: 800,
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    },
    navigation: {
        nextEl: ".next-arrow",
        prevEl: ".prev-arrow",
    },
    on: {
        slideChange: function() {
            updatePagination();

            const activeSlide = this.slides[this.activeIndex];
            const content = activeSlide.querySelector('.content-hero');

            if (content) {
                content.style.opacity = "0";
                content.style.transform = "translateY(20px)";

                setTimeout(() => {
                    content.style.transition = "opacity 0.5s ease, transform 0.5s ease";
                    content.style.opacity = "1";
                    content.style.transform = "translateY(0)";
                }, 100);
            }
        },
        autoplayTimeLeft(s, time, progress) {
            progressBar.style.transition = "width 0.1s linear";
            progressBar.style.width = `${(1 - progress) * 100}%`;
        },
        init: function() {
            const activeSlide = this.slides[this.activeIndex];
            const content = activeSlide.querySelector('.content-hero');

            if (content) {
                content.style.transition = "opacity 0.5s ease, transform 0.5s ease";
                content.style.opacity = "1";
                content.style.transform = "translateY(0)";
            }
        }
    }
});

function updatePagination() {
    let currentIndex = swiper.realIndex + 1;
    let totalSlides = swiper.realIndex + 2; // Adjust for cloned slides

    currentSlideEl.textContent = currentIndex.toString().padStart(2, '0');
    totalSlideEl.textContent = totalSlides.toString().padStart(2, '0');
}

// Reset the progress bar on manual navigation
document.querySelector('.prev-arrow').addEventListener('click', () => swiper.slidePrev());
document.querySelector('.next-arrow').addEventListener('click', () => swiper.slideNext());

updatePagination();

//glightbox
const lightbox = GLightbox({
})

document.querySelector('.svg-hero').addEventListener('click', function() {
    // Calculate 100vh in pixels
    const viewportHeight = window.innerHeight;

    // Scroll down by 100vh
    window.scrollBy({
      top: viewportHeight, // 100vh
      behavior: 'smooth' // Optional: for smooth scrolling
    });
  });


  // our section
  const container = document.querySelector(".wrapper-slider");

    const swiper2 = new Swiper(".swiper-our", {
        slidesPerView: "auto",
        spaceBetween: 50,
        loop: true,
        speed: 6000,
        freeMode: true,
        allowTouchMove: false,
        breakpoints: {
            1100: {
                spaceBetween: 23,
            }
        },
        autoplay: {
            delay: 0,
        },
    });

    function stopAutoplay(){
        const swiperTranslate = swiper2.getTranslate();
        swiper2.setTranslate(swiperTranslate);
        swiper2.autoplay.stop();
    }

    function startAutoplay(){
        swiper2.slideTo(swiper2.activeIndex, 3000, false);
        swiper2.autoplay.start();
    }

container.addEventListener("mouseenter", () => stopAutoplay());
container.addEventListener("mouseleave", () => startAutoplay());


// our section 2
const container2 = document.querySelector(".wrapper-slider2");

const swiper3 = new Swiper(".swiper-our2", {
    slidesPerView: "auto",
    spaceBetween: 25,
    loop: true,
    speed: 6000,
    freeMode: true,
    allowTouchMove: false,
    breakpoints: {
        1100: {
            spaceBetween: 23,
        }
    },
    autoplay: {
        delay: 0,
    },
});


swiper3.changeLanguageDirection('rtl');

function stopAutoplay2() {
    const swiperTranslate = swiper3.getTranslate();
    swiper3.setTranslate(swiperTranslate);
    swiper3.autoplay.stop();
}

function startAutoplay2() {
    swiper3.slideTo(swiper3.activeIndex, 3000, false);
    swiper3.autoplay.start();
}

container2.addEventListener("mouseenter", () => stopAutoplay2());
container2.addEventListener("mouseleave", () => startAutoplay2());

// Video background functionality
document.querySelectorAll('.play-btn').forEach(btn => {
    btn.addEventListener('click', function(e) {
        e.preventDefault();
        const slide = this.closest('.swiper-slide');
        const videoUrl = this.dataset.videoUrl;
        const videoWrapper = slide.querySelector('.video-wrapper');
        const iframe = slide.querySelector('.video-iframe');
        const image = slide.querySelector('.img-bg-hero');
        const loader = slide.querySelector('.loader');

        // If video is already playing, close it
        if (videoWrapper.style.display === 'block') {
            videoWrapper.classList.remove('active');
            setTimeout(() => {
                iframe.src = '';
                videoWrapper.style.display = 'none';
                image.classList.remove('hidden');
                // Reset button text and icon
                this.innerHTML = '<span><img src="/site/img/icons/play.webp" alt=""></span>Assista ao vídeo';
                swiper.autoplay.start();
            }, 300);
            return;
        }

        // Show loader
        loader.classList.add('active');

        // Convert YouTube URL to embed URL
        let embedUrl = videoUrl;
        if (videoUrl.includes('youtube.com') || videoUrl.includes('youtu.be')) {
            const videoId = videoUrl.match(/(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/i)?.[1];
            if (videoId) {
                embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&controls=0&showinfo=0&rel=0&loop=1&playlist=${videoId}`;
            }
        } else if (videoUrl.includes('vimeo.com')) {
            const videoId = videoUrl.match(/vimeo\.com\/(?:.*#|.*\/videos\/)?([0-9]+)/i)?.[1];
            if (videoId) {
                embedUrl = `https://player.vimeo.com/video/${videoId}?autoplay=1&loop=1&background=1`;
            }
        }

        // Set iframe source and handle loading
        iframe.addEventListener('load', function() {
            // Hide loader and show video
            loader.classList.remove('active');
            videoWrapper.style.display = 'block';
            // Small delay to ensure smooth transition
            setTimeout(() => {
                videoWrapper.classList.add('active');
                image.classList.add('hidden');
            }, 50);
        }, { once: true });

        iframe.src = embedUrl;

        // Pause autoplay when video is playing
        swiper.autoplay.stop();

        // Change button text and icon to close
        this.innerHTML = '<span class="play-btn-stop"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pause-fill" viewBox="0 0 16 16"><path d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5m5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5"/></svg></span>Fechar vídeo';
    });
});

document.querySelectorAll('[hasVideo]').forEach(divWrapper => {
    const btnId = divWrapper.getAttribute('idVideoBtn');

    const btn = document.getElementById(btnId);
    const slide = divWrapper.closest('.swiper-slide');
    const videoUrl = divWrapper.getAttribute('hasVideo');
    const videoWrapper = slide.querySelector('.video-wrapper');
    const iframe = slide.querySelector('.video-iframe');
    const image = slide.querySelector('.img-bg-hero');
    const loader = slide.querySelector('.loader');

    // Show loader
    loader.classList.add('active');

    // Convert YouTube URL to embed URL
    let embedUrl = videoUrl;
    if (videoUrl.includes('youtube.com') || videoUrl.includes('youtu.be')) {
        const videoId = videoUrl.match(/(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/i)?.[1];
        if (videoId) {
            embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&controls=0&showinfo=0&rel=0&loop=1&playlist=${videoId}`;
        }
    } else if (videoUrl.includes('vimeo.com')) {
        const videoId = videoUrl.match(/vimeo\.com\/(?:.*#|.*\/videos\/)?([0-9]+)/i)?.[1];
        if (videoId) {
            embedUrl = `https://player.vimeo.com/video/${videoId}?autoplay=1&loop=1&background=1`;
        }
    }

    // Set iframe source and handle loading
    iframe.addEventListener('load', function() {
        // Hide loader and show video
        loader.classList.remove('active');
        videoWrapper.style.display = 'block';
        // Small delay to ensure smooth transition
        setTimeout(() => {
            videoWrapper.classList.add('active');
            image.classList.add('hidden');
        }, 50);
    }, { once: true });

    iframe.src = embedUrl;

    // Pause autoplay when video is playing
    swiper.autoplay.stop();

    // Change button text and icon to close
    btn.innerHTML = '<span class="play-btn-stop"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pause-fill" viewBox="0 0 16 16"><path d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5m5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5"/></svg></span>Fechar vídeo';
});

// Update the slide change handler to reset the play button
swiper.on('slideChange', () => {
    const prevSlide = swiper.slides[swiper.previousIndex];

    if (prevSlide) {
        const iframe = prevSlide.querySelector('.video-iframe');
        const videoWrapper = prevSlide.querySelector('.video-wrapper');
        const image = prevSlide.querySelector('.img-bg-hero');
        const loader = prevSlide.querySelector('.loader');
        const playBtn = prevSlide.querySelector('.play-btn');

        videoWrapper?.classList.remove('active');
        loader?.classList.remove('active');

        setTimeout(() => {
            if (iframe) iframe.src = '';
            if (videoWrapper) videoWrapper.style.display = 'none';
            if (image) image.classList.remove('hidden');
            if (playBtn) playBtn.innerHTML = '<span><img src="/site/img/icons/play.webp" alt=""></span>Assista ao vídeo';
        }, 300);
    }

    swiper.autoplay.start();
});

// Add CSS for content animation to the head
const style = document.createElement('style');
style.textContent = `
    .content-hero {
        opacity: 0;
        transform: translateY(20px);
        transition: opacity 0.5s ease, transform 0.5s ease;
    }
`;
document.head.appendChild(style);

// Initialize GLightbox for video links
const videoLightbox = GLightbox({
    selector: '.glightbox-video',
    touchNavigation: true,
    loop: false,
    autoplayVideos: true
});

document.addEventListener('DOMContentLoaded', () => {
    // Remove the previous modal handling code and replace with this simpler version
    function handleWinerieClick(e) {
        // Don't prevent default - let the link redirect naturally
        // The modal will be handled by the wineries page JS
        return true;
    }

    // Add click handlers to all winery cards in the sliders
    document.querySelectorAll('.swiper-our .swiper-slide a, .swiper-our2 .swiper-slide a').forEach(link => {
        link.addEventListener('click', handleWinerieClick);
    });
});


